/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Supplier } from '@src/app/model/supplier';
import { uuid } from '@src/app/model/abstract-object';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SupplierService extends AbstractHttpService {

    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);
    protected get baseUrl() {
        return this.getAjaxPath('suppliers');
    }
    protected cache: Supplier[];
    protected typeString = 'Supplier';

    agentMap = new Map<uuid, Supplier[]>();

    getAgentTypes(agentTeamId: uuid): Observable<Supplier[]> {
        if (this.agentMap.has(agentTeamId)) {
            return of(this.agentMap.get(agentTeamId));
        } else {
            return this.http.get<Supplier[]>(this.baseUrl + '/agentTypes/' + agentTeamId).pipe(
                map(types => {
                    this.agentMap.set(agentTeamId, types);
                    return types;
                })
            );
        }
    }
    performMerge(remove: Supplier, mergeIntoId: uuid): Observable<Supplier> {
        const url = this.baseUrl + '/merge/' + remove.id + '/' + mergeIntoId;
        return this.http.post<Supplier>(url, { }, this.getSimpleOptions(remove.teamId)).pipe(
            map(x => {
                return x;
            }),
            catchError((error) => {
                this.messageService.showError(error, 'Performing Merge');
                return of(null);
            })
        )
    }    
}
